import { useTranslation } from 'react-i18next'

import { Text } from '@mercai/clever'

import styles from './agent-jtbd.module.css'
import { getAgentJtbdStatusDisplay } from './agent-jtbd.constants'
import { AgentJtbdProps, AgentEvaluationProps } from './agent-jtbd.type'
import { IAConversationExtraDataEvaluationProps } from '@/types/ai.type'

export const AgentJtbd = ({ evaluation }: AgentJtbdProps) => {
  const { t } = useTranslation('screenAiCenter')

  const agentEvaluations: AgentEvaluationProps[] =
    (evaluation as IAConversationExtraDataEvaluationProps)?.agentEvaluations ||
    []
  const agentsObservation =
    (evaluation as IAConversationExtraDataEvaluationProps)?.agentsObservation ||
    ''

  const completedAgents = agentEvaluations.filter(
    (agent) => agent.isJtbdCompleted,
  ).length
  const totalAgents = agentEvaluations.length
  const successRate =
    totalAgents > 0 ? Math.round((completedAgents / totalAgents) * 100) : 0

  if (!agentEvaluations.length) {
    return (
      <div className={styles['jtbd-section']}>
        <Text>{t('conversationShowAgentJtbdEmpty')}</Text>
      </div>
    )
  }

  return (
    <div className={styles['jtbd-section']}>
      <div className={styles.statistics}>
        <Text variant="text-medium" className={styles.bold}>
          {t('conversationShowAgentJtbdSubtitle')}
        </Text>
        <Text variant="text-medium" className={styles['success-rate']}>
          ({completedAgents}/{totalAgents} - {successRate}%)
        </Text>
      </div>

      {agentsObservation && (
        <div className={styles['agents-observation']}>
          <Text variant="text-small">{agentsObservation}</Text>
        </div>
      )}

      <div className={styles['agents-list']}>
        {agentEvaluations.map((agent, index) => {
          const statusData = getAgentJtbdStatusDisplay(t, agent.isJtbdCompleted)

          return (
            <div
              key={`${agent.agent}-${index}`}
              className={styles['agent-item']}
            >
              <div className={styles['agent-icon']}>{statusData.emoji}</div>
              <Text variant="text-medium" className={styles['agent-name']}>
                {agent.agent}
              </Text>
              <div
                className={`${styles['agent-status']} ${styles[statusData.color]}`}
              >
                <Text variant="text-small">{statusData.text}</Text>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
